import { render, staticRenderFns } from "./h2Title.vue?vue&type=template&id=7b418bf4&"
import script from "./h2Title.vue?vue&type=script&lang=js&"
export * from "./h2Title.vue?vue&type=script&lang=js&"
import style0 from "./h2Title.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports